"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
moment_1.default.updateLocale('en', {
    calendar: {
        lastDay: '[Yesterday,] LT',
        sameDay: '[Today,] LT',
        nextDay: '[Tomorrow at] LT',
        lastWeek: '[Last] ddd, LT',
        nextWeek: '[Next] ddd [at] LT',
        sameElse: 'MMM D, YYYY',
    },
    week: {
        dow: 1,
        doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
});
exports.default = moment_1.default;
//# sourceMappingURL=moment.js.map